// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[role=tooltip] {
  display: none;
}

button:hover + [role=tooltip],
button:focus + [role=tooltip] {
  display: block;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/tooltip/tooltip.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;;EAEE,cAAA;AACF","sourcesContent":["[role='tooltip'] {\n  display: none;\n}\n\nbutton:hover + [role='tooltip'],\nbutton:focus + [role='tooltip'] {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
